import { Link } from "react-router-dom";
import RoosterLogo from "@/components/RoosterLogo";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#F9F9F9]">
      <header className="border-b border-black/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <RoosterLogo size={36} />
            <div className="font-display text-2xl font-black tracking-tighter">Weathervane</div>
          </Link>
        </div>
      </header>
      <section className="max-w-2xl mx-auto px-6 lg:px-12 py-24">
        <div className="border border-black bg-white p-10" data-testid="notfound-card">
          <div className="ticker-label mb-3">404</div>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter">
            That page blew away.
          </h1>
          <p className="mt-6 text-neutral-700">
            The link you followed doesn&rsquo;t match anything on Weathervane. It may be outdated, or the page has moved.
          </p>
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="btn-brutal mt-8 inline-flex items-center gap-3 px-6 py-3 text-sm tracking-[0.14em] uppercase font-semibold"
          >
            Back to home
          </Link>
        </div>
      </section>
    </div>
  );
}
